import React, { useEffect } from "react";
import IndexNav from "../../IndexNav";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Content,
  LeftSide,
  RightSide,
  LeftWrapper,
  Title,
  Text,
  Button,
  SvgItem,
} from "./Styled";

const Index = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Quản lý nhiệm vụ";
  }, []);
  return (
    <>
      <IndexNav />
      <Container>
        <Content>
          <LeftSide>
            <LeftWrapper>
              <Title>Công cụ giúp đội ngũ đẩy mạnh công việc.</Title>
              <Text>
                Hợp tác, quản lý dự án và đạt đến đỉnh cao năng suất mới. Từ tòa
                nhà cao tầng đến văn phòng tại nhà, cách thức làm việc của đội
                ngũ bạn là độc đáo—hoàn thành tất cả với công cụ này.
              </Text>
              <Button onClick={() => navigate("/register")}>
                Đăng ký - miễn phí
              </Button>
            </LeftWrapper>
          </LeftSide>
          <RightSide>
            <SvgItem src="https://images.ctfassets.net/rz1oowkt5gyp/5QIzYxue6b7raOnVFtMyQs/113acb8633ee8f0c9cb305d3a228823c/hero.png?w=1200&fm=webp" />
          </RightSide>
        </Content>
      </Container>
    </>
  );
};

export default Index;
